import linkViewModel from '@vimcar/mvvm/linkViewModel'
import Button from '@vimcar/shared-components/components/Button'
import * as React from 'react'

import type { ViewModel } from './viewModel'

import i18n from '../../utils/i18n'
import styles from './styles.css'
import mkViewModel from './viewModel'

const tp = i18n.prefixWithoutTestId('BottomActions')

export type ButtonProps = {
  highlighted: boolean
  handleClick: () => void
  text: string
  subtext: string
}

type Props = {
  showBack: boolean
  onNext: () => void
  backEnabled: boolean
  nextEnabled: boolean
  customCaptions: {
    back?: string
    next?: string
  }
  extraButtons: Array<ButtonProps>
  loading?: boolean | null
  viewModel: ViewModel
}

const BottomActions = ({
  showBack,
  onNext,
  backEnabled = true,
  nextEnabled = true,
  customCaptions,
  extraButtons = [],
  loading = false,
  viewModel,
}: Props) => (
  <div className={styles.container}>
    {showBack && (
      <Button
        className={styles.button}
        disabled={!backEnabled || loading}
        loading={loading}
        // @ts-expect-error@2322
        onClick={viewModel.handleBack}
        primary
        type='button'
      >
        {(customCaptions && customCaptions.back) || tp('back')}
      </Button>
    )}
    {extraButtons.map((option, index) => (
      <Button
        className={styles.button}
        disabled={loading}
        key={index}
        loading={loading}
        // @ts-expect-error@2322
        onClick={option.handleClick}
        primary={!option.highlighted}
        raised={option.highlighted}
        type='button'
      >
        {option.text}
        {option.subtext && <br />}
        {option.subtext}
      </Button>
    ))}
    {onNext && (
      <Button
        className={styles.button}
        disabled={!nextEnabled || loading}
        loading={loading}
        // @ts-expect-error@2322
        onClick={onNext}
        raised
        type='button'
      >
        {(customCaptions && customCaptions.next) || tp('continue')}
      </Button>
    )}
  </div>
)

const component = linkViewModel(mkViewModel, BottomActions)
component.displayName = 'BottomActions'
export default component
